import Vue from "vue";
import api from "@/api/order";
const openGeocoder = require("node-open-geocoder");
import { errorHandler } from "../exports/error_management";
import { StorageCache } from "../exports/dataStorage";
import router from "../route/index";

const prefixKey = "ams-orders-prefix-key";

const getSuffixKey = (obj) => `-${btoa(JSON.stringify(obj))}`;
function isValidPayload(payload) {
  if (!payload || !payload.file.name || !payload.file.id) {
    return false;
  }
  return true;
}
const commitItems = (data, commit) => {
  console.log("commitItems data", data);
  const orderItems = [...data].map((x) => {
    x.deleted = false;
    return x;
  });
  commit("SET_ORDER_ITEMS", orderItems);
};

const commitAssetRentalItems = (data, commit) => {
  console.log("commitItems data", data);
  const orderItems = [...data].map((x) => {
    x.deleted = false;
    return x;
  });
  commit("SET_ORDER_ASSET_RENTAL_ITEMS", orderItems);
};

const commitItemsResult = (result, commit, note = "") => {
  console.log("commitItemsResult note", note);
  const {
    data: {
      success: { data },
    },
  } = result;
  commitItems(data, commit);
};

const commitAssetRentalItemsResult = (result, commit, note = "") => {
  console.log("commitItemsResult note", note);
  const {
    data: {
      success: { data },
    },
  } = result;
  commitAssetRentalItems(data, commit);
};

const resetStorage = () => {
  new StorageCache(prefixKey, true).reset();
};

const reloadOrders = async ({ state, dispatch }) => {
  resetStorage();
  console.log("reloading");
  const page = 1;
  const filters = state.filters;
  const query = state.query;
  const isforcedReload = true;
  await dispatch("fetch", { query, filters, page, isforcedReload });
};

const processOrder = async (
  { commit, state, getters },
  id,
  asyncCallBack,
  setOrder = null
) => {
  try {
    if (id > 0) {
      console.log("processOrder:", id);
      commit && commit("SET_ORDER_LOADING_STATE", true);

      let order = null;
      if (asyncCallBack && typeof asyncCallBack == "function") {
        const result = await asyncCallBack();
        if (setOrder && typeof setOrder == "function") {
          order = setOrder(result);
        }
      }
      if (!order) {
        const result = await api.fetchById(id);
        order = result.data.success.data;
      }
      const orders = [...state.items];
      const idx = orders.findIndex((x) => x.id == id);
      if (idx >= 0) {
        orders.splice(idx, 1, order);

        const obj = {
          page: getters["page"],
          filters: state.filters,
          query: state.query,
        };
        const suffixKey = getSuffixKey(obj);
        console.log("keys:", { suffixKey, prefixKey });
        const storageCache = new StorageCache(prefixKey, suffixKey);
        const { is_valid, value } = storageCache.getObject();
        if (is_valid) {
          value.data = orders;
          storageCache.set(value);
        } else {
          storageCache.reset();
        }
      }
      if (commit) {
        commit("SET_ORDER", order);
      } else {
        return order;
      }
    } else {
      if (commit) {
        commit("SET_ORDER", {});
      } else {
        return null;
      }
    }
  } catch (err) {
    console.log("fetch err", err);
    errorHandler(err);
  } finally {
    commit && commit("SET_ORDER_LOADING_STATE", false);
  }
};

const state = {
  items: [],
  item: {},
  pagination: null,
  drivers: [],
  customers: [],
  myorders: [],
  orderItems: [],
  orderAssetRentalItems: [],
  scheduleDate: "",
  orderLoadingState: false,
  query: "",
  filters: {},
  auditLogs: [],
  attachments: [],
  notes: [],
  checkoffs: [],
  receivedBy: {},
  deposit_of_invoice_total : 0,
  deposit_rental_item_value : 0,
  deposit_flat_amount : 0, 
  total_deposit_amount : 0,
  show_deposit :false,
  rental_days : 1,
};

const getters = {
  getScheduleDate: (state) => state.scheduleDate,
  page: (state) => state.pagination.page,
  depositRentalItemValue: (state) => state.deposit_rental_item_value,
  depositOfInvoiceTotal : (state) => state.deposit_of_invoice_total,
  depositFlatAmount : (state) => state.deposit_flat_amount,
  TotalDepositAmount : (state)=>state.total_deposit_amount,
  ShowDeposit : (state) => state.show_deposit,
  rentalDays : (state) => state.rental_days,
};

const mutations = {
  updateScheduleDate(state, date) {
    state.scheduleDate = date;
  },
  clearScheduleDate(state) {
    state.scheduleDate = null;
  },
  SetDepositRentalItemValue(state,value){
    console.log('rental value--------',value);
    state.deposit_rental_item_value = value;
  },
  SetDepositOfInvoiceTotal(state,value){
    console.log('invoice value--------',value);
    state.deposit_of_invoice_total = value;
  },
  SetDepositFlatAmount(state,value){
    console.log('flat value--------',value);
    state.deposit_flat_amount = value;
  },
  SetTotalDepositAmount(state,value){
    console.log('Total deposit value--------',value);
    state.total_deposit_amount = value;
  },
  SetDepositShow(state,value){
    state.show_deposit  = value;
  },
  SetRentalDays(state,value){
    state.rental_days  = value;
  },
  SET_ORDERS(state, payload) {
    console.log("orders----payload", payload);
    state.items = payload;
  },
  // SET_ORDERS(state, payload) {
  //     console.log('orders----payload', payload)
  //     state.items = payload
  // },
  SET_ORDER(state, order) {
    state.item = order;
  },

  SET_PAGINATION(state, pag) {
    state.pagination = pag;
  },
  SET_DRIVERS(state, drivers) {
    state.drivers = drivers;
  },
  SET_FILTERS(state, filters) {
    state.filters = filters;
  },
  SET_QUERY(state, query) {
    state.query = query;
  },

  SET_ORDER_ITEMS(state, orderItems) {
    console.log("SET_ORDER_ITEMS", orderItems);
    state.orderItems = [...orderItems];
  },

  SET_ORDER_ASSET_RENTAL_ITEMS(state, orderItems) {
    console.log("SET_ORDER_ASSET_RENTAL_ITEMS", orderItems);
    state.orderAssetRentalItems = [...orderItems];
  },

  SET_ORDER_LOADING_STATE(state, orderLoadingState) {
    state.orderLoadingState = orderLoadingState;
  },

  SET_AUDIT_LOGS(state, auditLogs) {
    state.auditLogs = auditLogs;
  },

  SET_NOTES(state, notes) {
    state.notes = notes;
  },

  SET_ATTACHMENTS(state, attachments) {
    state.attachments = attachments;
  },
  SET_CHECKOFFS(state, checkoffs) {
    state.checkoffs = checkoffs;
  },
  SET_RECEIVED_BY(state, receivedBy) {
    state.receivedBy = receivedBy;
  },
};

function isJsonString(str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}

function allOrdersStorage() {
  var values = [],
    keys = Object.keys(localStorage),
    i = keys.length;

  while (i--) {
    try {
      var value = '';
      if(Vue?.prototype?.$secureStorage?.decrypt(localStorage?.getItem(keys[i]))) {
        value = isJsonString(Vue.prototype.$secureStorage.decrypt(localStorage.getItem(keys[i]))) ? JSON.parse(
          Vue.prototype.$secureStorage.decrypt(localStorage.getItem(keys[i]))
        ) : null

        value = isJsonString(value) ? JSON.parse(value) : null
      }

      if (value?.value?.prefixKey && value?.value?.prefixKey?.includes(prefixKey)) {
        values.push({
          key: keys[i],
          value: value,
        });
      }
    } catch (err) {
      console.log("allOrdersStorage err", err);
    }
  }

  return values;
}

function remove_extra_orders_from_storage(stored_orders, current_page) {
  console.log("stored_orders", stored_orders);
  if (!stored_orders.length > 0) return;
  const pages = [
    current_page - 2,
    current_page - 1,
    current_page,
    current_page + 1,
    current_page + 2,
  ];

  stored_orders.forEach(({ key, value }) => {
    // remove pages which are not in pages array
    if (
      !pages.some(
        (page) => page === (value && value.value && value.value.current_page)
      )
    ) {
      localStorage.removeItem(key);
    }
  });
}
const actions = {

  clearOrderItem(context){
    context.commit("SET_ORDER_ITEMS",[]);
  },
  /* Checkoff */
  async createCheckoff(context, { id, data }) {
    // const callback = async () => await api.createCheckoff(id, data);
    // return await processOrder(context, id, callback);

    const result = await api.createCheckoff(id, data);
    context.commit("SET_CHECKOFFS", result.data.success.data)

  },

  async updateCheckoff(context, { id, data, order_checkoff_id }) {
    // const callback = async () =>
    //   await api.updateCheckoff(id, order_checkoff_id, data);
    // return await processOrder(context, id, callback);

    const result = await api.updateCheckoff(id, order_checkoff_id,data);
    context.commit("SET_CHECKOFFS", result.data.success.data)

  },

  async deleteCheckoff(context, { id, order_checkoff_id }) {
    const callback = async () =>
      await api.deleteCheckoff(id, order_checkoff_id);
    return await processOrder(context, id, callback);
  },

  //bulk checkoff
  async selectCheckoffOrders(context, params) {
    try {
      let { page: pg, reviewFilter } = params || {};
      pg = pg || 1;
      const result = await api.selectCheckoffOrders(pg, reviewFilter);
      let data = result.data.success.data;
      context.commit("SET_ORDERS", data.data);
      context.commit("SET_PAGINATION", {
        page: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      });
      // await reloadOrders(context)
    } catch (err) {
      errorHandler(err);
    }
  },

  async bulkCheckoffOrders(context, payload) {
    try {
      await api.bulkCheckoffOrders(payload);
      await reloadOrders(context);
    } catch (err) {
      errorHandler(err);
    }
  },

  //checkoff attachment
  async addCheckoffAttachment(
    context,
    { id, order_checkoff_id, url, name, file_extension }
  ) {
    try {
      // const setOrder = (result) => result.data.success.data;
      // const callback = async () =>
      //   await api.addCheckoffAttachment(
      //     id,
      //     order_checkoff_id,
      //     url,
      //     name,
      //     file_extension
      //   );
        // return await processOrder(context, id, callback, setOrder);

        const result = await api.addCheckoffAttachment(
          id,
          order_checkoff_id,
          url,
          name,
          file_extension
        );
        context.commit("SET_CHECKOFFS", result.data.success.data)
    } catch (err) {
      errorHandler(err);
    }
  },

  async deleteCheckoffAttachment(
    context,
    { id, order_checkoff_id, attachment_id }
  ) {
    try {
      resetStorage();
      const result = await api.deleteCheckoffAttachment(
        id,
        order_checkoff_id,
        attachment_id
      );
      const order = result.data.success.data;
      context.commit("SET_ORDER", order);
    } catch (err) {
      errorHandler(err);
    }
  },

  async renameCheckoffAttachment(context, payload) {
    try {
      if (!isValidPayload(payload)) throw new Error("Data Required");
      await api.renameCheckoffAttachment(payload.file.id, payload.file.name);
    } catch (err) {
      errorHandler(err);
    }
  },

  //////////////////////////////////////////////////////////////

  async uploadOrder(context, payload) {
    try {
      resetStorage();
      const result = await api.uploadOrder(payload);

      let success = result.data.success;
      let { data } = success == undefined ? {} : success;
      if (!data) return result.data.success || result.data.error;
      console.log("uploadOrder data", data);

      /* const orders = [...state.items]
            const idx = orders.findIndex(x => x.id === data.id)
            orders.splice(idx === -1 ? orders.length : idx, 1, data) */
      //// commit('SET_ORDERS', orders)

      return result.data.success;
    } catch (err) {
      errorHandler(err);
    }
  },
  //////orderItems section
  async fetchOrderItems(context, id) {
    try {
      const result = await api.fetchOrderItems(id);
      commitItemsResult(result, context.commit, "fetchOrderItems");
    } catch (err) {
      errorHandler(err);
    }
  },
    //////orderItems section
    async fetchOrderAssetRentalItems(context, id) {
      try {
        const result = await api.fetchOrderAssetRentalItems(id);
        commitAssetRentalItemsResult(result, context.commit, "fetchOrderAssetRentalItems");
      } catch (err) {
        errorHandler(err);
      }
    },

  async createTemplate(context, { id, template }) {
    try {
      resetStorage();
      const result = await api.createTemplate(id, template);
      return result.data.success.data;
    } catch (err) {
      errorHandler(err);
    }
  },

  async updateOrderItems(context, { id, total, arrangedItems, items }) {
    try {
      resetStorage();
      const result = await api.updateOrderItems(id, {
        total,
        items,
        arrangedItems,
      });
      commitItemsResult(result, context.commit, "updateOrderItems");
      const order = { ...context.state.item };
      order.total_price = total;
      context.commit("SET_ORDER", order);
    } catch (err) {
      errorHandler(err);
    }
  },

  async updateOrderItem(context, { order_id, id, item }) {
    try {
      resetStorage();
      const result = await api.updateOrderItem(order_id, id, item);
      commitItemsResult(result, context.commit, "updateOrderItem");
    } catch (err) {
      errorHandler(err);
    }
  },

  async createOrderItem(context, { order_id, item }) {
    try {
      resetStorage();
      const result = await api.createOrderItem(order_id, item);
      commitItemsResult(result, context.commit, "createOrderItem");
    } catch (err) {
      errorHandler(err);
    }
  },

  async deleteOrderItem(context, { order_id, id }) {
    try {
      resetStorage();
      const result = await api.deleteOrderItem(order_id, id);
      commitItemsResult(result, context.commit, "deleteOrderItem");
    } catch (err) {
      errorHandler(err);
    }
  },

  ////////////orderItems section
  async myorders() {
    const result = await api.myorders();
    console.log({ result });
  },

  async markAsComplete(context, { id, address }) {
    const callback = async () => await api.markAsComplete(id, address);
    const order = await processOrder(context, id, callback);
    context.commit("SET_RECEIVED_BY",{})
    await context.dispatch("fetchReceivedBy", id);
    return order;
  },

  async customerSignoff(context, { id, address }) {
    try {
      resetStorage();
      const res = await api.customerSignoff(id, address);
      return res.data.success.data;
    } catch (err) {
      console.log("create err", err);
      errorHandler(err);
    }
  },

  async markAsIncomplete(context, id) {
    const callback = async () => await api.markAsIncomplete(id);
    return await processOrder(context, id, callback);
  },

  async markAsRelease(context, id) {
    const callback = async () => await api.markAsRelease(id);
    context.commit("SET_RECEIVED_BY",{})
    const order = await processOrder(context, id, callback)
    await context.dispatch("fetchReceivedBy", id)
    return order;
  },

  async create(context, payload) {
    try {
      resetStorage();
      const res = await api.create(payload);
      return res.data.success.data;
    } catch (err) {
      console.log("create err", err);
      errorHandler(err);
    }
  },

  async fetchById(context, id) {
    return await processOrder(context, id);
  },
  async fetchByIdDirect({ state, getters }, id) {
    return await processOrder({ state, getters }, id);
  },

  async fetch(
    { dispatch, rootState, commit },
    { query, filters, page: page_no, isforcedReload },
    
  ) {
    console.log("fetch", { isforcedReload });
    filters = filters || {};
    query = query || "";
    page_no = page_no || 1;

    commit("SET_FILTERS", filters);
    commit("SET_QUERY", query);

    const obj = {
      page: page_no,
      filters,
      query,
    };

    isforcedReload = !!isforcedReload;

    const suffixKey = getSuffixKey(obj);
    const storageCache = new StorageCache(prefixKey, suffixKey);
    let value;
    let is_valid = false;

    if (isforcedReload) {
      is_valid = false;
    } else {
      const { is_valid: _is_valid, value: _value } = storageCache.getObject();
      is_valid = _is_valid;
      value = _value;
    }

    if (!is_valid) {
      page_no = parseInt(page_no) || 1;
      dispatch("itemType/fetchAll", {}, { root: true });

      const result = await api.fetch(query, filters, page_no);
      console.log("result", result);

      const data = result.data.success.data;
      storageCache.set(data);
      value = data;
    }

    const {
      data: _orders = [],
      current_page: page = 1,
      per_page: pageSize = 10,
      total = 0,
    } = value || {};

    const stored_orders = allOrdersStorage() || [];
    page && remove_extra_orders_from_storage(stored_orders, page || 1);

    const getTasks = (items) =>
      (items || []).filter(
        (_item) =>
          !!(
            rootState.itemType.items.find(
              (_type) => _type.id === _item.order_item_type_id
            ) || {}
          ).is_task
      );

    let orders =
      _orders &&
      _orders.map((o) => {
        const tasks = getTasks(o.items);
        o.totalTasks = tasks.length;
        o.completedTasks = tasks.filter((x) => x.task_checked).length;
        o.taskCompletion =
          o.totalTasks > 0 ? (o.completedTasks / o.totalTasks) * 100 : 0;
        o.checked = o.taskCompletion == 100;
        return o;
      });

    commit("SET_PAGINATION", {
      page,
      pageSize,
      total,
    });
    console.log("ordersasssadad", orders);

    commit("SET_ORDERS", orders);
  },

  async fetchSchedule({ commit }, { query, filters }) {
    const result = await api.fetchSchedule(query, filters);
    let _orders = result.data.success.data;
    commit("SET_ORDERS", _orders);
  },

  async fetchDirect(_, { query, filters, page: page_no }) {
    page_no = parseInt(page_no) || 1;
    const result = await api.fetch(query, filters, page_no);
    let { data } = result.data.success.data;
    return data;
  },

  async update(context, payload) {
    try {
      const { id } = payload;
      console.log("update order--", id);
      const setOrder = (result) => result.data.success.data;
      const callback = async () => await api.update(id, payload);
      return await processOrder(context, id, callback, setOrder);
    } catch (err) {
      console.log("update err", err);
      errorHandler(err);
    }
  },

  async delete(context, id) {
    try {
      await api.delete(id);
      await reloadOrders(context);
    } catch (err) {
      errorHandler(err);
    }
  },

  async duplicate_order(context, payload) {
    try {
      const order = await api.duplicate_order(payload);
      context.commit("SET_ORDER", order);
      router.push("/ams/activities/" + order.data.success.data.id);
      return order.data.success.data;
    } catch (err) {
      console.log("duplicate order err", err);
      errorHandler(err);
    }
  },

  async bulkSetDriver(context, payload) {
    try {
      await api.bulkSetDriver(payload.orders, payload.driverId);
      await reloadOrders(context);
    } catch (err) {
      errorHandler(err);
    }
  },

  async bulkSetWarehouse(context, payload) {
    try {
      resetStorage();
      await api.bulkSetWarehouse(payload.orders, payload.warehouseId);
    } catch (err) {
      errorHandler(err);
    }
  },

  async bulkRelease(context, payload) {
    try {
      // resetStorage()
      await api.bulkRelease(payload.orders);
      await reloadOrders(context);
    } catch (err) {
      errorHandler(err);
    }
  },
  async bulkCheckoff(context, payload) {
    try {
      // resetStorage()
      await api.bulkCheckoff(payload);
      await reloadOrders(context);
    } catch (err) {
      errorHandler(err);
    }
  },

  async bulkSetIncomplete(context, payload) {
    try {
      await api.bulkSetIncomplete(payload);
      await reloadOrders(context);
    } catch (err) {
      errorHandler(err);
    }
  },
  async updateItemOrder(context, payload) {
    try {
      await api.updateItemOrder(payload);
    } catch (err) {
      errorHandler(err);
    }
  },
  async bulkSetcomplete(context, payload) {
    try {
      const results = await api.bulkSetcomplete(payload);
      console.log("bulkSetcomplete data:", results);
      await reloadOrders(context);
      const error_list = results.data.success.data;
      if (error_list.length > 0) {
        throw new Error(error_list[0].message);
      }
    } catch (err) {
      errorHandler(err);
    }
  },

  async bulkDelete(context, payload) {
    try {
      // resetStorage()
      await api.bulkDelete(payload.orders);
      await reloadOrders(context);
    } catch (err) {
      errorHandler(err);
    }
  },
  //////
  async fetchDrivers(context) {
    try {
      // resetStorage()
      const result = await api.fetchDrivers();
      await reloadOrders(context);
      context.commit("SET_DRIVERS", result.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  //////
  async fetchDriversNew(context) {
    try {
      // resetStorage()
      const result = await api.fetchDriversNew();
      await reloadOrders(context);
      context.commit("SET_DRIVERS", result.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  //
  async deleteAttachment(context, { order_id, attachment_id }) {
    try {
      // const callback = async () =>
      //   api.deleteAttachment(order_id, attachment_id);
      // return await processOrder(context, order_id, callback);

      const result = await api.deleteAttachment(order_id, attachment_id);
      context.commit("SET_ATTACHMENTS", result.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async addAttachment(context, payload) {
    try {
      // const callback = async () => await api.addAttachment(payload);
      // return await processOrder(context, payload.order_id, callback);

      const result = await api.addAttachment(payload);
      context.commit("SET_ATTACHMENTS", result.data.success.data);

    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchPresigned(context, key) {
    try {
      const url = await api.fetchPresigned(key);
      return url;
    } catch (err) {
      errorHandler(err);
    }
  },

  geocodeStreet(context, payload) {
    return new Promise((resolve) => {
      let q = `${payload.lat}, ${payload.long}`;
      console.log("map query:", q);
      openGeocoder({
        port: 443,
      });
      openGeocoder()
        .geocode(q)
        .end((err, res) => {
          if (err) {
            console.error("geocodeStreet--err", err);
            //reject(err)
            return resolve();
          } else {
            return resolve(res);
          }
        });
    });
  },
  async fetchAuditLogs(context, order_id) {
    try {
      // if (
      //   state.auditLogs.length > 0 &&
      //   state.auditLogs[0].order_id == order_id
      // ) {
      //   return;
      // }
      const result = await api.fetchAuditLogs(order_id);

      context.commit("SET_AUDIT_LOGS", result.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchAttachments(context, order_id) {
    console.log('attachment is called');
    try {
      if(context.rootState.orderAttachmentsStore.attachments.length > 0){
        return;
      }
      if (
        state.attachments.length > 0 &&
        state.attachments[0].order_id == order_id
      ) {
        return;
      }
      const result = await api.fetchAttachments(order_id);

      context.commit("SET_ATTACHMENTS", result.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchNotes(context, order_id) {
    try {
      // if(context.rootState.orderMessagesStore.messages.length > 0){
      //   return;
      // }
      // if (
      //   state.notes.length > 0 &&
      //   state.notes[0].order_id == order_id
      // ) {
      //   return;
      // }
      const result = await api.fetchNotes(order_id);

      context.commit("SET_NOTES", result.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchCheckoffs(context, order_id) {
    try {
      if (
        state.checkoffs.length > 0 &&
        state.checkoffs[0].order_id == order_id
      ) {
        return;
      }
      const result = await api.fetchCheckoffs(order_id);

      context.commit("SET_CHECKOFFS", result.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchReceivedBy(context, order_id) {
    try {
      if (
        state.receivedBy &&
        state.receivedBy.id == order_id
      ) {
        return;
      }
      const result = await api.fetchReceivedBy(order_id);

      context.commit("SET_RECEIVED_BY", result.data.success.data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async bulkStatement(context, payload) {
    try {
      const { export_option} = payload;
      let orderIdsString;
      if (payload.orders.length > 1) {
        orderIdsString = payload.orders.join(',');
      } else if (payload.orders.length === 1) {
        orderIdsString = payload.orders[0].toString();
      } else {
       
        orderIdsString = ''; 
      }
   
      const response = await api.bulkStatement(orderIdsString,export_option);
      var blob;
      if(export_option == 'pdf'){
         blob = new Blob([response.data], {
          type: "application/pdf", // Set the MIME type to 'application/pdf' for PDF files
        });
      }else if(export_option == 'excel'){
        blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // Set the MIME type to 'application/pdf' for PDF files
        });
      }else{
         blob = new Blob([response.data], {
          type: "application/vnd.ms-word", // Set the MIME type to 'application/pdf' for PDF files
        });
      }
     
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      if(export_option == 'pdf'){
      link.setAttribute("download",  "Activity_Statement.pdf");
      }else if(export_option == 'excel'){
        link.setAttribute("download",  "Activity_Statement.xlsx");
      }else{
        link.setAttribute("download",  "Activity_Statement.doc");
      } // Set the filename with the appropriate extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error fetching request:", err);
    }
  },

  async generateReceipt(context, payload) {
    try {
    
      let orderIdsString;
      if (payload.orders.length > 1) {
        orderIdsString = payload.orders.join(',');
      } else if (payload.orders.length === 1) {
        orderIdsString = payload.orders[0].toString();
      } else {
       
        orderIdsString = ''; 
      }
   
      const response = await api.generateReceipt(orderIdsString);
      var blob;
      
         blob = new Blob([response.data], {
          type: "application/pdf", // Set the MIME type to 'application/pdf' for PDF files
        });
     
     
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (err) {
      console.error("Error fetching request:", err);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
